export const OCTAVE_IN_SEMITONE = 12;
export const LOWEST_C_KEY = 4;
